export function removeDecimal(decimalString) {
  if (isNaN(decimalString)) return "";
  if (decimalString === "") return "";
  decimalString = decimalString.toString();
  if (!decimalString.includes(".")) return decimalString;
  return decimalString.substring(0, decimalString.indexOf("."));
}

export function roundString(stringNum, decimals) {
  if (!stringNum.includes(".")) return stringNum;
  return stringNum.substring(0, stringNum.indexOf(".") + decimals + 1);
}
